import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';

import styles from './Section.styles';

class Section extends React.Component {
  render() {
    const { children, subtitle, title, labelInfo, displayLabelInfo, classes } = this.props;

    return (
      <div className={classes.wrapper}>
        <div className={classes.titleWrapper}>
          {title !== '' && (
            <div className={classes.title}>
              {title}
              {subtitle}
            </div>
          )}
          {displayLabelInfo && labelInfo ? (
            <div className={classes.labelInfoWrapper}>
              <div className={classes.labelInfoText}>{labelInfo}</div>
            </div>
          ) : null}
        </div>
        <div className={classes.content}>{children}</div>
      </div>
    );
  }
}

Section.propTypes = {
  children: PropTypes.node,
  subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

Section.defaultProps = {
  title: '',
  subtitle: null,
};

export default withStyles(styles)(Section);
